<template>
  <div>
    <vs-popup
      class="deliverer-modal"
      :title="getNameTitle"
      :active.sync="showPopup"
      v-if="staff !== null"
    >
      <template>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Naam"
              :value="staff.firstname"
              v-model="staff.firstname"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="staff.insertion !== null">
            <vs-input

              class="w-full"
              label="Tussenvoegsel"
              :value="staff.insertion"
              v-model="staff.insertion"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Achternaam"
              v-if="staff.lastname"
              :value="staff.lastname"
              v-model="staff.lastname"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              class="w-full"
              type="email"
              label="E-mail"
              :value="staff.email"
              v-model="staff.email"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              class="w-full"
              label="Telefoonnummer"
              :value="staff.phone_number"
              v-model="staff.phone_number"
            />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="staff.last_login !== null">
          <div class="vx-col sm:w-1/2 w-full">

          <vs-input
                  class="w-full"
                  label="Laatste login"
                  :value="staff.last_login"
                  v-model="staff.last_login"
          />

          </div>
        </div>
        <div class="vx-row mb-6" v-if="staff.role.name !== null">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-select v-model="staff.role.name">
              <vs-select-item
                v-for="(item) in roles"
                :key="item.name"
                :value="item"
                :text="item.name"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2 vs-con-loading__container" ref="loadableButton" id="save-staff-button" @click="saveStaffModel(staff, false)">Opslaan</vs-button>
            <vs-button color="danger" type="filled" @click="fireStaff(staff)">Ontslaan</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>

    <vs-popup class="deliverer-modal" :title="getCreateTitle" :active.sync="showCreatePopup">
      <template>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Naam"
              :value="createStaff.firstname"
              v-model="createStaff.firstname"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="createStaff.insertion !== null">
            <vs-input
              class="w-full"
              label="Tussenvoegsel"
              :value="createStaff.insertion"
              v-model="createStaff.insertion"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Achternaam"
              :value="createStaff.lastname"
              v-model="createStaff.lastname"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              class="w-full"
              type="email"
              label="E-mail"
              :value="createStaff.email"
              v-model="createStaff.email"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              class="w-full"
              label="Telefoonnummer"
              :value="createStaff.phone_number"
              v-model="createStaff.phone_number"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-select v-model="createStaff.role">
              <vs-select-item
                v-for="(item) in roles"
                :key="item.name"
                :value="item.name"
                :text="item.name"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" ref="loadableButton" @click="saveStaffModel(createStaff, true)">Opslaan</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ht-staff-popup",
  computed: {
    getNameTitle: function () {
      if (this.staff.firstname === null) {
        return "Vul een naam in";
      }
      return (
        this.staff.firstname +
        " " +
        (this.staff.insertion !== null ? this.staff.insertion + " " : "") +
        this.staff.lastname
      );
    },
    getCreateTitle: function () {
      if (this.createStaff.firstname !== "") {
        return (
          this.createStaff.firstname +
          " " +
          (this.createStaff.insertion !== null
            ? this.createStaff.insertion + " "
            : "") +
          this.createStaff.lastname
        );
      } else {
        return "Medewerker Aanmaken";
      }
    },
  },
  data() {
    return {
      staff: null,
      showPopup: false,
      showCreatePopup: false,
      roles: [
        {
          id: 1,
          name: "Administrator",
        },
        {
          id: 2,
          name: "Senior Developer",
        },
        {
          id: 3,
          name: "Junior Developer",
        },
        {
          id: 4,
          name: "Finance Manager",
        },
        {
          id: 5,
          name: "Finance Worker",
        },
        {
          id: 6,
          name: "Customer Support Manager",
        },
        {
          id: 7,
          name: "Customer Support Worker",
        },
        {
          id: 8,
          name: "Sales Manager",
        },
        {
          id: 9,
          name: "Sales Worker",
        },
        {
          id: 10,
          name: "Depot Coördinator",
        },
        {
          id: 11,
          name: "Regio Manager",
        },
      ],
      createStaff: {
        id: null,
        firstname: "",
        insertion: "",
        lastname: "",
        area: "Spijkenisse",
        email: "",
        phone_number: "",
        role: "Customer Support Worker",
      },
    };
  },
  mounted() {
    this.$events.listen("open-staff-modal", (staff) => {
      this.staff = staff;
      this.showPopup = true;
      console.log(staff);
    });
    this.$events.listen("create-staff-modal", (event) => {
      this.showCreatePopup = true;
    });
    window.addEventListener('keyup', (key) => {
      if (key.keyCode === 27) {
        this.showCreatePopup = false;
        this.showPopup = false;
      }
    });
  },
  methods: {
    getRoleId(role) {
      let roleId = 0;
      this.roles.forEach((element) => {
        if (element.name === role) {
          console.log(element.id);
          roleId = element.id;
        }
      });

      return roleId;
    },
    saveStaffModel(staff, create) {
      let data = {
        _method: create ? "POST" : "PUT",
        id: staff.id,
        area: staff.area,
        firstname: staff.firstname,
        insertion: staff.insertion,
        lastname: staff.lastname,
        phone_number: staff.phone_number,
        email: staff.email,
        staff_role_id: create ? this.getRoleId(staff.role) : this.getRoleId(staff.role.name),
      };

      let url = create
        ? "https://staffapi.hebtrek.nl/v1/staff/create"
        : "https://staffapi.hebtrek.nl/v1/staff/update";
      this.$http
        .post(url, data, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
          },
        })
        .then((response) => {
          this.saved = true;
          this.showCreatePopup = false;
          this.showPopup = false;
          this.$vs.notify({
            title: "Gelukt!",
            text: "Gegevens voor " + staff.firstname + " zijn opgeslagen!",
            color: "green",
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
    fireStaff(staff) {
      let data = {
        _method: "DELETE",
        id: staff.id,
        reason: "Ontslagen op staande voet",
      };
      this.$http
        .post("https://staffapi.hebtrek.nl/v1/staff/fire", data, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
          },
        })
        .then((response) => {
          this.showPopup = false;
          this.$vs.notify({
            title: "Doei",
            text: "Je hebt " + staff.firstname + " ontslagen",
            color: "red",
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
  },
};
</script>
